import styled from "styled-components";

export const RoomContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  min-width: 100%;
  min-height: 100%;
  margin-top: 1.5em;

  @media only screen and (max-width: 520px) {
    flex-flow: column wrap;
    align-items: center;
  }
`;
